<template>
  <div class="main">
    <div class="wrapper">
      <h3>
        <strong>
          <span>爱艺术</span>
        </strong>
        <strong>+</strong>
        <strong>
          <span>用户付费</span>
        </strong>
        <strong>
          <span>协议</span>
        </strong>
        <strong></strong>
      </h3>
      <p class="commonCss">
        <strong>
          <span>
            1.
            <span>协议条款的确认和接纳</span>
          </span>
        </strong>
        <strong></strong>
      </p>
      <p class="commonCss">
        <span>
          1.1
          <span>欢迎使用</span>
        </span>
        <span>爱艺术</span>
        <span>+</span>
        <span>服务，为保障您的权益，请您在</span>
        <span>付费</span>
        <span>之前，详细阅读本协议的所有内容，</span>
        <strong>
          <span>特别是加粗部分</span>
        </strong>
        <span>。本协议内容包括协议正文、本协议下述明确援引的其他协议（包括但不限于《</span>
        <span>爱艺术</span>
        <span>+</span>
        <span>用户服务协议》、《</span>
        <span>隐私信息保护政策</span>
        <span>》）、</span>
        <span>爱艺术</span>
        <span>+</span>
        <span>已经发布的或将来可能发布的各类规则。所有协议内容为本协议不可分割的组成部分，与本协议正文具有同等法律效力。除另行明确声明外，您使用</span>
        <span>
          <span>爱艺术</span>+
        </span>
        <span>服务的付费行为将受本协议约束。</span>
      </p>
      <p class="commonCss">
        <span>1.2</span>
        <strong>
          <span>
            <span>您应该具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备签署与您行为相适应的民事行为能力，请确保您的监护人同意您的所有行为，在此情况下，您及您的监护人应依照法律规定承担因此而导致的一切后果。当您选择</span>“点击同意”的或者以其他方式开始使用
          </span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>付费服务的，即表示已经与</span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>达成协议，并自愿接受本协议的所有内容</span>
        </strong>
        <span>。</span>
      </p>
      <p class="commonCss">
        <span>1.3</span>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>有权根据法律规范及运营的合理需要，不断修改和完善本协议，并在</span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>平台（</span>
        </strong>
        <strong>
          <span>www.iartschool.com</span>
        </strong>
        <strong>
          <span>）公告。如您继续使用</span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>的付费服务，即意味着同意并自愿遵守修改后的协议条款，亦或您有权终止使用</span>
        </strong>
        <span>。</span>
      </p>
      <p class="commonCss">
        <span>&nbsp;</span>
      </p>
      <p class="commonCss">
        <span>
          2.
          <span>定义</span>
        </span>
      </p>
      <p class="commonCss">
        <span>2.1</span>
        <span>
          <span>爱艺术</span>+
        </span>
        <span>平台（或</span>
        <span>
          <span>爱艺术</span>+
        </span>
        <span>不时修改的其他名称）：为用户提供教学内容的传播和消费服务，由</span>
        <span>
          <span>爱艺术</span>+
        </span>
        <span>
          <span>所有和经营的有关教育、学习等数字内容聚合、管理和分发的平台产品，包括但不限于</span>web
          <span>端（网站网址：</span>
        </span>
        <span>www.iartschool.com</span>
        <span>及其不时更换的域名）及其各移动端（包括但不限于更新后的版本）。</span>
      </p>
      <p class="commonCss">
        <span>
          2.2
          <span>课程发布者：指</span>
        </span>
        <span>课程版权所有人或获得合法授权的爱艺术</span>
        <span>+</span>
        <span>。</span>
      </p>
      <p class="commonCss">
        <span>
          2.3
          <span>课程：指在</span>
        </span>
        <span>
          <span>爱艺术</span>+
        </span>
        <span>
          <span>平台上陈列、展示，供用户观看、学习的视频、语音、文字、图片、链接等课程作品</span>/
          <span>制品。</span>
        </span>
      </p>
      <p class="commonCss">
        <span>
          2.4
          <span>收费课程：指</span>
        </span>
        <span>
          <span>爱艺术</span>+
        </span>
        <span>有偿提供的，供用户付费观看、使用的课程。</span>
      </p>
      <p class="commonCss">
        <span>
          2.5
          <span>付费服务：指按照本协议的约定，</span>
        </span>
        <span>
          <span>爱艺术</span>+
        </span>
        <span>在收到您支付的足额的费用后，向您提供对应收费课程的观看学习服务，以及</span>
        <span>
          <span>爱艺术</span>+
        </span>
        <span>推出的相关增值服务（比如</span>
        <span>
          <span>爱艺术</span>+
        </span>
        <span>
          VIP
          <span>会员服务）。</span>
        </span>
      </p>
      <p class="commonCss">
        <span>&nbsp;</span>
      </p>
      <p class="commonCss">
        <span>
          3.
          <span>付费服务规范和用户规则</span>
        </span>
      </p>
      <p class="commonCss">
        <span>3.1</span>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>作为</span>
        </strong>
        <strong>
          <span>受托</span>
        </strong>
        <strong>
          <span>收费课程提供方，或者直接作为收费课程的售卖方</span>
        </strong>
        <strong>
          <span>，</span>
        </strong>
        <strong>
          <span>为您提供</span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>平台的收费课程，或者为您提供其他增值服务</span>
        </strong>
        <span>。</span>
      </p>
      <p class="commonCss">
        <span>
          3.2
          <span>您可在</span>
        </span>
        <span>
          <span>爱艺术</span>+
        </span>
        <span>平台上浏览发布的收费课程与相关增值服务信息，如您希望有偿获得该部分服务，请您务必仔细了解本协议及确认相关具体信息（包括但不限于</span>
        <span>授课的老师、</span>
        <span>课程的内容、开课的时间、课程价格等），并根据操作提示，确认自己的账号并选择相关操作选项。</span>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>发布的付费服务可能对使用的时间、次数等做出一定限制；如超出限制范围，可能影响您继续使用该等服务，您需要再次付费购买</span>
        </strong>
        <span>。</span>
      </p>
      <p class="commonCss">
        <span>
          3.3
          <span>您理解并同意：</span>
        </span>
        <span>
          <span>爱艺术</span>+
        </span>
        <span>提供付费服务实行先付款后使用的方式，您及时、足额、合法的支付所需的款项是您获得该等服务的前提。</span>
        <strong>
          <span>您有权选择使用</span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>认可的支付方式，您理解并确认支付服务由</span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>之外具备合法资质的第三方提供，该等支付服务的使用条件及规范由您与支付服务提供方确定，与</span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>无关</span>
        </strong>
        <span>。</span>
      </p>
      <p class="commonCss">
        <span>3.4</span>
        <strong>
          <span>请您注意，在符合相关法律法规规定的情况下，</span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>有权根据本协议规定对您购买的付费服务不予退款。</span>
        </strong>
        <strong>
          <span>除爱艺术</span>
        </strong>
        <strong>
          <span>+</span>
        </strong>
        <strong>
          <span>技术原因外，</span>
        </strong>
        <strong>
          <span>您购买付费服务后</span>
        </strong>
        <strong>
          <span>，</span>
        </strong>
        <strong>
          <span>爱艺术</span>
        </strong>
        <strong>
          <span>+</span>
        </strong>
        <strong>
          <span>对您购买的付费服务</span>
        </strong>
        <strong>
          <span>不予退款。</span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>
            <span>技术原因是指：包括但不限于由技术故障引发的连续超过</span>24
            <span>小时课程无法正常观看、视频无法正常播放、重复购买课程等；如因您的个人网络原因、观看设备故障、账号丢失等类原因不属于平台技术故障。除非法律法规另有规定或本协议另有约定外，您购买付费服务</span>
          </span>
        </strong>
        <strong>
          <span>后</span>
        </strong>
        <strong>
          <span>，一律不予退款。参加特价优惠或促销活动的退款规则以具体活动规则为准。以上规则适用于</span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>
            <span>安卓版以及</span>PC
            <span>客户端、网页版，但是通过</span>
            <span>IOS</span>
            <span>版购买的课程不适用前述规则，通过</span>
            <span>IOS</span>
            <span>版购买的课程适用苹果公司的退款规则</span>
          </span>
        </strong>
        <span>。</span>
      </p>
      <p class="commonCss">
        <span>3.5</span>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>对所提供的付费服务的适用性或满足您特定需求及目的不承担任何明示或者默示的担保。请您在付费前确认自身的需求，同时仔细阅读相关课程的详情说明</span>
        </strong>
        <span>。</span>
      </p>
      <p class="commonCss">
        <span>
          3.6
          <span>您应当尊重</span>
        </span>
        <span>爱艺术</span>
        <span>+</span>
        <span>的知识产权</span>
        <span>。</span>
        <strong>
          <span>您知悉并同意，您购买的付费服务仅限于您自行使用，您无权对购买的收费课程及相关增值服务服务进行出售、转让、许可、传播或以其他方式使除您自己以外的第三方（包括但不限于自然人、法人或其他组织）使用。若您违反本条规定，则</span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>有权视情况采取如下措施而无需承担任何责任</span>
        </strong>
        <span>：</span>
      </p>
      <p class="commonCss">
        <span>3.6.1</span>
        <strong>
          <span>取消您继续使用该付费服务的权利</span>
        </strong>
        <span>；</span>
      </p>
      <p class="commonCss">
        <span>3.6.2</span>
        <strong>
          <span>限制、冻结、终止您的帐号</span>
        </strong>
        <span>；</span>
      </p>
      <p class="commonCss">
        <span>3.6.3</span>
        <strong>
          <span>要求您退还通过出售、转让、许可等其他方式取得的收益</span>
        </strong>
        <span>；</span>
      </p>
      <p class="commonCss">
        <span>3.6.4</span>
        <strong>
          <span>其他</span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>认为可以采取的救济措施</span>
        </strong>
        <span>。</span>
      </p>
      <p class="commonCss">
        <span>3.7</span>
        <strong>
          <span>您了解并同意，</span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>可能会基于自身原因（包括但不限于：更新课程内容、改进课程安排）不定期的对付费服务内容或功能进行更新而无需经过您的事先同意</span>
        </strong>
        <span>。</span>
      </p>
      <p class="commonCss">
        <span>3.8</span>
        <strong>
          <span>您通过</span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>平台支付的款项由</span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>收取，若您需要获取相关凭据，您可以联系</span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>或渠道商（包括但不限于苹果公司等）来获取相关凭证</span>
        </strong>
        <span>。</span>
      </p>
      <p class="commonCss">
        <span>
          3.9
          <span>您应保管好自己的帐号和密码，如因您未保管好自己的帐号和密码而对自己、</span>
        </span>
        <span>
          <span>爱艺术</span>+
        </span>
        <span>或第三方造成损害的，您将负全部责任。另外，您应对您帐号中的所有活动和事件负全责。您可随时改变帐号和密码。您同意若发现有非法使用您的帐号或出现安全漏洞的情况，立即通告</span>
        <span>
          <span>爱艺术</span>+
        </span>
        <span>，</span>
        <span>
          <span>爱艺术</span>+
        </span>
        <span>将会尽力予以妥善解决。</span>
      </p>
      <p class="commonCss">
        <span>3.10</span>
        <strong>
          <span>如果</span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>
            <span>发现因平台系统故障等原因（包括但不限于商品名称、价格或数量等关键信息存在错误等）导致的充值</span>/
            <span>购买结果处理错误，无论有利于</span>
          </span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>还是有利于您，</span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>都有权在以平台公告或其他合理方式通知您后纠正该错误（包括但不限于取消交易订单等）</span>
        </strong>
        <span>。</span>
      </p>
      <p class="commonCss">
        <span>
          3.11
          <span>您了解并确认，各渠道商可能会对充值渠道、充值频率等进行限定，并可能会要求</span>
        </span>
        <span>
          <span>爱艺术</span>+
        </span>
        <span>
          <span>隔离不同系统、不同应用商店适用的移动客户端及</span>/
          <span>或未来增加的</span>
        </span>
        <span>
          <span>爱艺术</span>+
        </span>
        <span>平台的账号信息，包括账号余额、账号交易记录等。</span>
      </p>
      <p class="commonCss">
        <span>&nbsp;</span>
      </p>
      <p class="commonCss">
        <span>
          4.
          <span>服务终止</span>
        </span>
      </p>
      <p class="commonCss">
        <span>4.1</span>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>根据自身商业决策等原因可能会选择终止</span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>的付费服务。如有此等情形发生，</span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>会采取公告或其他合适的方式通知您，并以您购买收费课程但未实际使用（即您付费购买收费课程后尚未实际点击观看课程之情形）的费用为限，将上述费用返还至您的购买账户中。除法律有明确规定的情况外，</span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>有权不经您申请并直接为您办理退款</span>
        </strong>
        <span>。</span>
      </p>
      <p class="commonCss">
        <span>4.2</span>
        <strong>
          <span>经国家行政或司法机关的生效法律文书确认您存在违法或侵权行为的，或者</span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>根据自身的判断、认为您的行为涉嫌违反本协议内容的，或涉嫌违反法律法规的规定的，则</span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>有权中止、中断或终止向您提供付费服务，并无需向您退还任何费用以及不承担任何责任</span>
        </strong>
        <span>。</span>
      </p>
      <p class="commonCss">
        <span>&nbsp;</span>
      </p>
      <p class="commonCss">
        <span>
          5.
          <span>其他约定</span>
        </span>
      </p>
      <p class="commonCss">
        <span>
          5.1
          <span>除非另有证明，</span>
        </span>
        <span>
          <span>爱艺术</span>+
        </span>
        <span>储存在其服务器上的数据是您使用</span>
        <span>
          <span>爱艺术</span>+
        </span>
        <span>付费服务的唯一有效证据。</span>
      </p>
      <p class="commonCss">
        <span>5.2</span>
        <strong>
          <span>不可抗力：</span>
        </strong>
        <strong>
          <span>
            <span>爱艺术</span>+
          </span>
        </strong>
        <strong>
          <span>对不可抗力导致的损失不承担责任。本协议所指不可抗力包括但不限于：天灾、法律法规或政府指令的变更，因网络服务特性而特有的原因，例如境内外基础电信运营商的故障、计算机或互联网相关技术缺陷、互联网覆盖范围限制、计算机病毒、黑客攻击等因素，及其他合法范围内的不能预见、不能避免并不能克服的客观情况</span>
        </strong>
        <span>。</span>
      </p>
      <p class="commonCss">
        <span>
          5.3
          <span>通知：所有发给您的通知都可通过电子邮件、常规的信件或在网站显著位置公告的方式进行传送。</span>
        </span>
        <span>
          <span>爱艺术</span>+
        </span>
        <span>将通过上述方法之一将消息传递给您，告知您本协议的修改、付费服务变更、或其它重要事情。</span>
      </p>
      <p class="commonCss">
        <span>
          5.4
          <span>本协议自发布之日起实施，并构成您和</span>
        </span>
        <span>
          <span>爱艺术</span>+
        </span>
        <span>之间的共识。</span>
        <span>
          <span>爱艺术</span>+
        </span>
        <span>不行使、未能及时行使或者未充分行使本条款或者按照法律规定所享有的权利，不应被视为放弃该权利，也不影响</span>
        <span>
          <span>爱艺术</span>+
        </span>
        <span>在将来行使该权利</span>
      </p>
      <p class="commonCss">
        <span>5.5</span>
        <strong>
          <span>本协议适用中华人民共和国的法律（不含冲突法）。当本协议的任何内容与中华人民共和国法律相抵触时，应当以法律规定为准，同时相关内容将按法律规定进行修改或重新解释，而本协议其他部分的法律效力不变</span>
        </strong>
        <span>。</span>
      </p>
      <p class="commonCss">
        <span>5.6</span>
        <strong>
          <span>凡因本协议引起的或与本协议有关的任何争议，均应提交</span>
        </strong>
        <strong>
          <span>杭州</span>
        </strong>
        <strong>
          <span>
            <span>仲裁委员会，按照申请仲裁时该会现行有效的仲裁规则进行仲裁，并由</span>3
            <span>名仲裁员进行审理。仲裁裁决是终局的，对双方均有约束力</span>
          </span>
        </strong>
        <span>。</span>
      </p>
      <p class="commonCss">
        <span>
          5.7
          <span>如果您对本协议内容有任何疑问，请发送邮件至我们的客服邮箱：</span>
          <span>[</span>
        </span>
        <span>service@iartschool.com</span>
        <span>
          &nbsp;]
          <span>。</span>
        </span>
      </p>
      <p>
        <br />
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.main {
  color: #333;
  .wrapper {
    background: #fff;
    border-radius: 10px;
    padding: 16px;
    font-size: 16px;
    h3 {
      margin: 10px 0;
      break-after: avoid;
      text-align: center;
      line-height: 35px;
      font-weight: bold;
      font-size: 21px;
      color: rgb(0, 0, 0);
      text-indent: 0;
      strong {
        span {
          font-size: 21px;
        }
      }
    }
    .commonCss {
      margin: 10px 0;
      text-align: justify;
      font-size: 14px;
      color: rgb(0, 0, 0);
      text-indent: 0;
      line-height: 35px;
    }
  }
}
</style>